import { useAuth } from 'services/auth';

// Reactive auth state: re-renders on every auth store change (token rotation, logout, degraded).
export const useUserAuth = () => {
  const {
    status, token, login, logout, retrySession,
  } = useAuth();

  return {
    status,
    isAuthenticated: status === 'authenticated',
    token,
    login,
    logout,
    retrySession,
  };
};
